import Vue from 'vue'
import Router from 'vue-router'

const Index = () => import('@/pages/index')
const ProductList = () => import('@/pages/productList')
const Login = () => import('@/pages/login')
const Register = () => import('@/pages/register')
const ProductDetail = () => import('@/pages/productDetail')
const ProductPay = () => import('@/pages/productPay')
const WechatPay = () => import('@/pages/wechatPay')
const AliPay = () => import('@/pages/aliPay')
const NotFound = () => import('@/pages/404')
const ProductDredge = () => import('@/pages/productdredge')
const paySuccess = () => import('@/pages/paySuccess')

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'home',
			component: Index
		}, {
			path: '/home',
			name: 'Query',
			component: Index
		}, {
			path: '/list',
			name: 'ProductList',
			component: ProductList
		}, {
			path: '/login',
			name: 'Login',
			component: Login,
			meta: {
				single: true
			}
		}, {
			path: '/register',
			name: 'Register',
			component: Register,
			meta: {
				single: true
			}
		}, {
			path: '/product-detail',
			name: 'ProductDetail',
			component: ProductDetail
		}, {
			path: '/product-pay',
			name: 'ProductPay',
			component: ProductPay
		}, {
			path: '/wechat-pay',
			name: 'WechatPay',
			component: WechatPay,
			meta: {
				single: true
			}
		}, {
			path: '/ali-pay',
			name: 'AliPay',
			component: AliPay,
			meta: {
				single: true
			}
		},
		{
			path: '/product-dredge',
			name: 'ProductDredge',
			component: ProductDredge
		}, {
			path: '/pay-success',
			name: 'paySuccess',
			component: paySuccess
		}, {
			path: '/*',
			name: 'NotFound',
			component: NotFound
		}
	],
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
})



// WEBPACK FOOTER //
// ./src/router/index.js